import React, { useEffect, useState, useMemo } from "react";
import classes from "../../../assets/styles/Pages/CouponManagement/CouponManagement.module.css";
import { useAtom } from "jotai";
import { loggedInUser } from "../../../utils/store";
import Loader from "../../../components/Loader";
import "react-datepicker/dist/react-datepicker.css";
import { get, deleteRecord, put } from "../../../server";
import { PRODUCT_DISCOUNT_LINK } from "../../../utils/constants/apiUrl";
import showToast from "../../../helpers/showToast";
import { Link } from "react-router-dom";
import DataTable, { createTheme } from "react-data-table-component";
import { BsThreeDotsVertical } from "react-icons/bs";
import ConfirmationModal from "../../../components/Modals/ConfirmationModal";
import FormInput from "../../../components/Forms/FormInput";
import searchIcon from "../../../assets/images/global_icons/searchicon.svg";
import { useParams } from "react-router-dom";
const AllProductDiscountLink = () => {
  const [loggedUser, setLoggedUser] = useAtom(loggedInUser);
  const [loading, setLoading] = useState(false);
  const [filterText, setFilterText] = useState("");
  const [discounts, setDiscounts] = useState([]);
  const [showConfirmationModal, setShowConfirmationModal] = useState(false);
  const [deleteId, setDeleteId] = useState(null);
  const [statusId, setStatusId] = useState(null);
  const handleFilter = (e) => {
    setFilterText(e.target.value);
  };

  const loadProductDiscount = async () => {
    setLoading(true);
    let { status, message, data } = await get(
      PRODUCT_DISCOUNT_LINK,
      Object.keys(loggedUser).length !== 0 ? loggedUser.token : null
    );
    if (status) {
      if (data.length > 0) {
        setDiscounts(data);
        const status = data.map((statusValue) => statusValue.status);
        setStatusId(status);
      }
    } else {
      showToast(status, message);
    }
    setLoading(false);
  };

  const filteredItems = useMemo(() => {
    const filtered = discounts.filter(
      (item) =>
        `${item.name || ""}`.toLowerCase().includes(filterText.toLowerCase()) ||
        `${item.package.package_name || ""}`
          .toLowerCase()
          .includes(filterText.toLowerCase()) ||
        `${item.discount || ""}`.includes(filterText)
    );

    return filtered;
  }, [filterText, discounts]);

  createTheme(
    "solarized",
    {
      background: {
        default: "background: var(--secondary_color)",
      },
    },
    "dark"
  );

  const columns = [
    {
      name: "Product Link",
      width: "200px",
      cell: (row) => <p className="globalDetail">{row.link}</p>,
    },
    {
      name: "Package",
      width: "120px",
      cell: (row) => <p className="globalDetail">{row.package.package_name}</p>,
    },
    {
      name: "Package Type",
      width: "120px",
      cell: (row) => (
        <p className="globalDetail">
          {row.package.package_type.charAt(0).toUpperCase() +
            row.package.package_type.slice(1)}
        </p>
      ),
    },
    {
      name: "Description",
      cell: (row) => <p className="globalDetail">{row.description}</p>,
    },
    {
      name: "Status",
      width: "200px",
      //cell: (row) => <p className="globalDetail">{row.status}</p>,
      cell: (row) => {
        const statusText = row.status === 1 ? "Active" : "Inactive";
        return <p className="globalDetail">{statusText}</p>;
      },
    },
    {
      name: "Action",
      width: "100px",
      right: "true",
      cell: (row, index) => (
        <div className={classes.action}>
          <button
            className="btn customActionDropdown dropdown-toggle"
            type="button"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            <BsThreeDotsVertical className={"globalVerticalThreeDots"} />
          </button>
          <ul className="customActionDropdownMenu dropdown-menu dropdown-menu-end ">
            <li>
              <Link
                className="dropdown-item"
                to={`/productDiscountLink/addEditProductDiscountLink/${row.id}`}
              >
                Edit
              </Link>
            </li>
            <li>
              <Link
                className="dropdown-item"
                to="#"
                onClick={() => updateStatus(row.id)}
              >
                {/* Inactive */}
                {statusId[index] === 1 ? "Inactive" : "Active"}
              </Link>
            </li>
            <li>
              <Link
                className="dropdown-item"
                to="#"
                style={{ color: "#E35252" }}
                onClick={() => handleDelete(row.id)}
              >
                Delete
              </Link>
            </li>
          </ul>
        </div>
      ),
    },
  ];

  // Handle confirmation modal
  const handleShowConfirmationModal = () => setShowConfirmationModal(true);
  const handleCloseConfirmationModal = () => setShowConfirmationModal(false);

  // handle delete
  const handleDelete = (discountId) => {
    setDeleteId(discountId);
    handleShowConfirmationModal(true);
  };

  const handleConfirmDelete = async () => {
    handleCloseConfirmationModal(true);
    setLoading(true);
    let { status } = await deleteRecord(
      `${PRODUCT_DISCOUNT_LINK}/${deleteId}`,
      Object.keys(loggedUser).length !== 0 ? loggedUser.token : null
    );
    if (status) {
      await loadProductDiscount();
      setLoading(false);
    }
    setLoading(false);
  };

  const updateStatus = async (discountId) => {
    setLoading(true);
    setStatusId(discountId);
    let newStatus = 1;
    const discountIndex = discounts.findIndex((pkg) => pkg.id === discountId);
    if (discountIndex !== -1) {
      if (statusId[discountIndex] === 1) {
        newStatus = 0;
      }
    }
    const payload = {
      status: newStatus,
    };
    let { status, message } = await put(
      `${PRODUCT_DISCOUNT_LINK}/${discountId}/update/status`,
      payload,
      Object.keys(loggedUser).length !== 0 ? loggedUser.token : null
    );
    if (status) {
      await loadProductDiscount();
      setLoading(false);
    }
    setLoading(false);
  };

  useEffect(() => {
    loadProductDiscount();
  }, []);

  return (
    <>
      {!loading ? (
        <div>
          <div className="page_Header">
            <div className="d-flex justify-content-between align-items-md-center align-items-initial flex-md-row flex-column gap-3 mb-3">
              <div className="heading">
              <h1 className="pageTitle">
                Product Discount Link <span>({discounts.length})</span>
              </h1>
              </div>
              <div className="d-flex align-items-center justify-content gap-2 mb-2">
              <div className="input-group" style={{ maxWidth: "250px", height: "45px" }}>
                  <span className="input-group-text bg-white border-end-0">
                    <img
                      src={searchIcon}
                      alt="search"
                      style={{ height: "16px" }}
                    />
                  </span>
                  <input
                    type="text"
                    className="form-control border-start-0"
                    placeholder="Search..."
                    value={filterText}
                    onChange={handleFilter}
                  />
                </div>
                <div className="d-flex justify-content-end gap-2 mobileViewWrapper">
                  <Link to="/productDiscountLink/addEditProductDiscountLink" className="mobileViewWrapper">
                    <button className="primary_button">Add</button>
                  </Link>
                </div>
                {/* <FormInput
                  icon={searchIcon}
                  placeholder="Search..."
                  value={filterText}
                  handleChange={handleFilter}
                /> */}
                {/* <div className="input-group" style={{ maxWidth: "250px", height: "45px" }}>
                  <span className="input-group-text bg-white border-end-0">
                    <img
                      src={searchIcon}
                      alt="search"
                      style={{ height: "16px" }}
                    />
                  </span>
                  <input
                    type="text"
                    className="form-control border-start-0"
                    placeholder="Search..."
                    value={filterText}
                    onChange={handleFilter}
                  />
                </div> */}
              </div>
            </div>
          </div>
          {/* <div className='listingWrapper mainWrapper default-list-table'> */}
          <div className='default-list-table'>
            <DataTable
              columns={columns}
              data={filteredItems}
              pagination
              theme="solarized"
            />
          </div>

          <ConfirmationModal
            show={showConfirmationModal}
            handleCloseModal={handleCloseConfirmationModal}
            handleConfirmDelete={handleConfirmDelete}
            confirmTitle="coupon"
          />
        </div>
      ) : (
        <Loader />
      )}
    </>
  );
};

export default AllProductDiscountLink;
